import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../../../stores';
import * as styles from '../DesignSettingsPanel.css';
import * as adminStyles from '../../AdminStyles.css';
import { IATextField } from '../../../../textField/TextField';
import { IAColorPicker } from '../../../../colorPicker/ColorPicker';
import { IAOptionSelector } from '../../../../optionSelector/OptionSelector';
import { Environment } from '../../../../../services/Environment';
import { IANumberField } from '../../../../numberField/NumberField';
import { IAIcon } from '../../../../icon/Icon';
import { IAToggle } from '../../../../toggle/Toggle';
import { LocalizationService } from '../../../../../services/LocalizationService';
import { IAMediaSelector } from '../../../../mediaSelector/MediaSelector';

export interface IMenuBarSettingsProps {
  navigatorStore?: NavigatorStore;
}

@inject('navigatorStore')
@observer
export default class MenuBarSettings extends React.Component<IMenuBarSettingsProps> {
  constructor(props) {
    super(props);
  }

  public render(): JSX.Element {
    return (
      <div className={styles.pivotContentItem}>
        <IAMediaSelector
          label={new LocalizationService().strings.Navigator_MenuBarSettings_Logo}
          showPreview={true}
          fileType="image"
          highlightColor={this.props.navigatorStore.navigator.design.menuBar.highlightColor}
          token={this.props.navigatorStore.token}
          tenant={this.props.navigatorStore.tenant.substring(0, this.props.navigatorStore.tenant.indexOf('.'))}
          selectedImage={this.props.navigatorStore.navigator.design.menuBar.logo}
          environment={this.props.navigatorStore.environment}
          uploadUrl={`${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${
            this.props.navigatorStore.tenant
            }/image?type=logo`}
          onChange={(logoUrl: string) => {
            this.props.navigatorStore.setLogoUrl(logoUrl);
          }}
        />
        <div className={adminStyles.panelDivider} />
        <IATextField
          label={new LocalizationService().strings.Navigator_MenuBarSettings_Url}
          text={this.props.navigatorStore.navigator.design.menuBar.logoLinkUrl}
          onChange={(logoLinkUrl: string) => {
            this.props.navigatorStore.setLogoLinkUrl(logoLinkUrl);
          }}
          borderRadius={5}
          style={{
            marginTop: 20
          }}
        />
        <div className={adminStyles.panelDivider} />
        <IAColorPicker
          label={new LocalizationService().strings.Navigator_MenuBarSettings_MenuColor}
          color={this.props.navigatorStore.navigator.design.menuBar.backgroundColor}
          onChange={(color: string) => this.props.navigatorStore.setBackgroundColor(color)}
          showClearButton={false}
        />
        <IAColorPicker
          label={new LocalizationService().strings.Navigator_Design_IconColor}
          color={this.props.navigatorStore.navigator.design.menuBar.iconColor}
          onChange={(color: string) => this.props.navigatorStore.setIconColor(color)}
          showClearButton={false}
        />
        <IAColorPicker
          label={new LocalizationService().strings.Navigator_Design_HighlightColor}
          color={this.props.navigatorStore.navigator.design.menuBar.highlightColor}
          onChange={(color: string) => this.props.navigatorStore.setHighlightColor(color)}
          showClearButton={true}
        />
        {this.props.navigatorStore.navigator.design.menuBar.layout !== 'burger' && (
          <IAColorPicker
            label={new LocalizationService().strings.Navigator_Design_HighlightTextColor}
            color={this.props.navigatorStore.navigator.design.topItems.highlightTextColor}
            onChange={(color: string) => this.props.navigatorStore.setBurgerMenuHighlightTextColor(color)}
            showClearButton={false}
          />
        )}
        <div className={adminStyles.panelDivider} />
        <div>
          <IAOptionSelector
            label={new LocalizationService().strings.Navigator_MenuBarSettings_MenuLayout}
            options={[
              {
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/Line%20Horizontal%203/SVG/ic_fluent_line_horizontal_3_20_regular.svg",
                key: 'burger',
                text: new LocalizationService().strings.Navigator_MenuBarSettings_Burger,
              },
              {
                iconUrl: "https://intraactivestorage.blob.core.windows.net/cdn/icons/Web%20Asset/SVG/ic_fluent_web_asset_24_regular.svg",
                key: 'horizontal',
                text: new LocalizationService().strings.Navigator_MenuBarSettings_Horizontal,
              },
              // {
              //   icon: 'SidebarMenu',
              //   key: 'vertical',
              //   text: new LocalizationService().strings.Navigator_MenuBarSettings_Vertical,
              // },
            ]}
            selected={this.props.navigatorStore.navigator.design.menuBar.layout}
            highlightColor={this.props.navigatorStore.adminColor}
            borderRadius={5}
            onChange={(option: string) => {
              this.props.navigatorStore.setLayout(option);
              setTimeout(() => {
                this.props.navigatorStore.resize();
              }, 500);
            }}
          />
          {this.props.navigatorStore.navigator.design.menuBar.layout == 'vertical' && (
            <div className={styles.sidebarWarning}>
              <IAIcon
                title={'Info'}
                size={16}
                color={'gray'}
                style={{
                  float: 'left',
                  height: 12,
                  width: 16,
                  paddingRight: 3,
                }}
              />
              <span>{new LocalizationService().strings.Navigator_Design_SideBarWarning}</span>
            </div>
          )}
          {this.props.navigatorStore.navigator.design.menuBar.layout == 'vertical' && (
            <IAToggle
              label={new LocalizationService().strings.Navigator_Design_SlimPanel}
              checked={this.props.navigatorStore.navigator.design.menuBar.showSlimPanel}
              color={this.props.navigatorStore.adminColor}
              onChange={() => {
                this.props.navigatorStore.toggleSlimPanel();
                this.forceUpdate();
              }}
              style={{
                marginTop: 20,
              }}
            />
          )}
        </div>
        <div className={adminStyles.panelDivider} />
        <IANumberField
          label={new LocalizationService().strings.Navigator_Smartmenu_NumberOfItems}
          number={
            this.props.navigatorStore.navigator.design.menuBar.numberOfVisibleSmartmenuItems != undefined
              ? this.props.navigatorStore.navigator.design.menuBar.numberOfVisibleSmartmenuItems
              : 5
          }
          onChange={(value: number) => {
            this.props.navigatorStore.setNumberOfVisibleSmartmenuItems(value);
          }}
          borderRadius={5}
          styles={{
            width: '100%',
          }}
        />
      </div>
    );
  }
}
